<script setup lang="ts">
import type Product from "~/models/Product";
import SafeHtml from "@/components/utils/SafeHtml.vue";
import { formatPrice } from "@/utils/pricing";
import DiscountIcon from "@/components/icons/DiscountIcon.vue";

const props = defineProps<{ product: Product }>();
/**
 * TODAS LAS CLASES COMENTADAS OCULTAN EL EFECTO DE MOSTRAR LA PROMO CUANDO EL PUNTERO PASA POR ENCIMA PERO POR REQUISITO SE QUITÓ.
 */

const itemClasses =
  "d-flex gap-1 align-items-center justify-content-center border border-light-subtle p-1"; // "d-flex flex-column align-items-center justify-content-end";
const textClasses =
  "d-flex flex-column align-items-start justify-content-center lh-1";
// "d-flex flex-column align-items-center justify-content-center lh-1";

const couponWalletAmount = computed(() =>
  !props.product.coupon?.with_wallet
    ? 0
    : props.product.coupon.discount_percentage > 0
      ? (props.product.getFinalCurrentPrice() *
          props.product.coupon.discount_percentage) /
        100
      : props.product.coupon.discount_amount_with_iva,
);

onMounted(async () => {
  const { Tooltip } = await import("bootstrap");
  const tooltipTriggerList = Array.from(
    document.querySelectorAll(".month-wallet-tooltip"),
  );
  tooltipTriggerList.forEach(async (tooltipTriggerEl) => {
    new Tooltip(tooltipTriggerEl);
  });
});
</script>

<template>
  <!-- <ul
    class="product-card-promotion-list d-flex border border-light-subtle p-0 m-0 align-self-center"
  > -->
  <ul
    class="product-card-promotion-list d-flex gap-1 p-0 m-0 align-self-center"
  >
    <li
      v-if="
        product.wallet_promotion_amount > 0 ||
        product.mwi_wallet_amount_with_tax > 0
      "
      :class="itemClasses"
      @click.prevent
    >
      <i class="icon bi bi-credit-card text-success"></i>
      <p :class="textClasses">
        <safe-html
          tag="span"
          :html="
            formatPrice(
              product.wallet_promotion_amount ||
                product.mwi_wallet_amount_with_tax,
            )
          "
          class="highlight-text"
        />
        <span>
          Monedero
          <span
            v-if="product.mwi_wallet_amount_with_tax > 0"
            class="text-danger month-wallet-tooltip"
            style="font-size: 0.85rem; line-height: 0"
            data-bs-toggle="tooltip"
            data-bs-title="Aplica a un pago"
            data-bs-placement="right"
            >*</span
          >
        </span>
      </p>
    </li>
    <li v-if="product.hasDiscount()" :class="itemClasses" @click.prevent>
      <i class="icon bi bi-tag text-danger"></i>
      <p :class="textClasses">
        <span class="highlight-text"
          >-{{ product.getPercentDiscountText() }}</span
        >
        <span>Oferta</span>
      </p>
    </li>
    <li
      v-if="product.has_shipping_promotion"
      :class="itemClasses"
      @click.prevent
    >
      <i class="icon bi bi-truck text-success"></i>
      <p :class="textClasses">
        <span>Envío</span>
        <span>Gratis</span>
        <!-- <span><span class="highlight-text">3-5</span> días</span> -->
      </p>
    </li>
    <li v-if="product.coupon" :class="itemClasses" @click.prevent>
      <discount-icon class="icon text-info" />
      <p :class="textClasses">
        <template v-if="couponWalletAmount > 0">
          <safe-html
            tag="span"
            :html="formatPrice(couponWalletAmount)"
            class="highlight-text text-success"
          />
          <span
            >Cupón
            <span class="badge text-bg-light" style="padding: 0.1rem"
              >en monedero</span
            ></span
          >
        </template>
        <template v-else>
          <span>Aplica</span>
          <span class="highlight-text">Cupón</span>
        </template>
      </p>
    </li>
    <li v-if="product.has_last_stock" :class="itemClasses" @click.prevent>
      <i class="icon bi bi-fire text-fire"></i>
      <p :class="textClasses">
        <span>Últimas</span>
        <span class="highlight-text">Piezas</span>
      </p>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.product-card-promotion-list {
  list-style-type: none;
  li {
    .icon {
      font-size: $font-size-base * 1.1;
      align-self: center;
      color: var(--bs-gray-600);
      margin: auto;
    }
    p {
      color: var(--bs-gray-700);
      margin: 0;
      font-size: $font-size-base * 0.65;
      .highlight-text {
        font-weight: bold;
        font-size: $font-size-base * 0.7;
      }
    }
  }
}
</style>
